var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "genuine_confirm_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 8963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 14885",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.051 112.104C25.144 112.104 0 86.959 0 56.052C0 25.145 25.144 0 56.051 0C86.958 0 112.103 25.145 112.103 56.052C112.103 86.959 86.958 112.104 56.051 112.104ZM56.051 1.99999C26.2471 1.99999 2 26.2468 2 56.052C2 85.8569 26.2471 110.104 56.051 110.104C85.8562 110.104 110.103 85.8569 110.103 56.052C110.103 26.2468 85.8562 1.99999 56.051 1.99999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 8964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 14886",
    d: "M53.5884 79.4783L29.5542 52.5867L31.0464 51.2537L53.479 76.3552L84.7866 35.988L86.3667 37.2136L53.5884 79.4783Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.fdd333dc08208eaf0d82cae31d27305d.svg";
export { ForwardRef as ReactComponent };